import { createSlice } from "@reduxjs/toolkit";
import useApi from "../api";

interface ProductTypesState {
    results: any[];
    loaded: boolean;
}

const initialState: ProductTypesState = {
    results: [],
    loaded: false,
};

const productTypesSlice = createSlice({
    name: "productTypes",
    initialState,
    reducers: {
        setProductTypes(state, action) {
            state.results = action.payload; 
            state.loaded = true;
        },
    },
});


export const { setProductTypes } = productTypesSlice.actions;

export const fetchProductTypes = () => async (dispatch: any) => {
    const api = useApi();
    try {
        const response = await api.getProductType();
        dispatch(setProductTypes(response));
    } catch (error) {
        console.error("Error retrieving product types:", error);
    }
};

export default productTypesSlice.reducer;
